import { useState, useEffect } from "react";

const INTERVAL_MS = 5 * 60 * 1000; // 5 minutos

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`);
        if (!res.ok) return;
        const { version } = await res.json();
        if (version !== __APP_VERSION__) {
          setUpdateAvailable(true);
        }
      } catch {
        // sem conexão ou arquivo ausente — ignora silenciosamente
      }
    };

    const timer = setInterval(check, INTERVAL_MS);
    // primeira verificação após 30s (tempo de boot do container)
    const boot = setTimeout(check, 30_000);

    return () => {
      clearInterval(timer);
      clearTimeout(boot);
    };
  }, []);

  return { updateAvailable };
};
